<div class="forgot-password">
    <div class="forgot-password-card">
        @if (passwordReset()) {
            <h4 class="heading">Password Updated</h4>
            <p class="subheading">
                Your password has been updated. You can now log in with your new
                password.
            </p>

            <tools-button (onClick)="goToLogin()">Back to Login</tools-button>
        } @else if (!codeSent()) {
            <h4 class="heading">Forgot Password</h4>
            <p class="subheading">
                Enter your email and we’ll send password reset instructions.
            </p>

            <form
                [formGroup]="requestForm"
                (ngSubmit)="onRequestReset()"
                class="forgot-password-form"
            >
                <tools-input-outline
                    label="Email"
                    placeholder="Enter email"
                    formControlName="email"
                ></tools-input-outline>

                <tools-button
                    [type]="ButtonType.SUBMIT"
                    [isDisabled]="isRequestSubmitDisabled"
                >
                    Send Reset Instructions
                </tools-button>
            </form>
        } @else {
            <h4 class="heading">Check Your Email</h4>
            <p class="subheading">
                Enter the reset code from your email and choose a new password.
            </p>

            <form
                [formGroup]="confirmForm"
                (ngSubmit)="onConfirmReset()"
                class="forgot-password-form"
            >
                <tools-input-outline
                    label="Verification Code"
                    placeholder="Enter code"
                    formControlName="code"
                ></tools-input-outline>

                @if (resendSuccess()) {
                    <div class="resend-success">
                        <p>
                            A new reset code was sent to
                            <strong>{{ storedEmail() }}</strong>
                            . Use the latest code we sent.
                        </p>
                        <p class="resend-countdown">
                            Resend code in 30 seconds
                        </p>
                    </div>
                } @else {
                    <p class="resend-prompt">
                        Didn't get a code?
                        <a href="#" (click)="onResendCode($event)">
                            Resend Code
                        </a>
                    </p>
                }

                <tools-input-outline
                    label="New Password"
                    placeholder="Enter new password"
                    formControlName="newPassword"
                    [isPassword]="true"
                    [showVisibilityIcon]="true"
                ></tools-input-outline>

                @if (passwordStarted) {
                    <ul class="password-requirements">
                        @for (req of passwordRequirements; track req.label) {
                            <li [class.met]="req.met" [class.unmet]="!req.met">
                                @if (req.met) {
                                    <span class="icon-check"></span>
                                } @else {
                                    <span class="icon-placeholder"></span>
                                }
                                {{ req.label }}
                            </li>
                        }
                    </ul>
                }

                <tools-input-outline
                    label="Confirm New Password"
                    placeholder="Confirm new password"
                    formControlName="confirmPassword"
                    [isPassword]="true"
                    [showVisibilityIcon]="true"
                ></tools-input-outline>

                @if (
                    confirmForm.errors?.["passwordsMismatch"] &&
                    confirmForm.get("confirmPassword")?.touched
                ) {
                    <p class="field-error">Passwords do not match.</p>
                }

                <tools-button
                    [type]="ButtonType.SUBMIT"
                    [isDisabled]="isConfirmSubmitDisabled"
                >
                    Reset Password
                </tools-button>
            </form>
        }

        @if (!passwordReset()) {
            <p>
                Remember your password?
                <a routerLink="/login">Log in</a>
            </p>
        }
    </div>

    <div class="forgot-password-secondary">
        <p>
            SiriusXM employee?
            <a href="#" (click)="signInWithOkta(); $event.preventDefault()">
                Sign in with SSO
            </a>
        </p>
    </div>
</div>
